type User = {
  id?: string
  email: string
  name: string
  password?: string
  token?: string
  isAdmin: boolean
  isEmployee: boolean
}
export default User

export const userToJson = (user: User) => {
  const {email, password, name, isAdmin, isEmployee, token} = user
  return {email, password, name, isAdmin, isEmployee, token}
}

export const userFromJson = (json: object) => json as User
